import { VNode, h } from "preact";
import { InputLine } from "./InputLine.js";
import { UIFormProps } from "./FormProvider.js";

export function InputTextArea<T extends object, K extends keyof T>(
  props: UIFormProps<T, K>,
): VNode {
  return <InputLine type="text-area" {...props} />;
}
